import firebase from 'firebase/compat/app';
import { firebaseConfig, firebaseConfigFormularios } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import Swal from 'sweetalert';
import { enviarEmailObrigado } from '../email/obrigado';

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
const auth = firebase.auth();
const database = firebase.database();
const storage = firebase.storage();

//const firebaseFormularios = firebase.apps.length <= 1 ? firebase.initializeApp(firebaseConfigFormularios, 'formularios') : null;
const firebaseFormularios = firebase.initializeApp(firebaseConfigFormularios, 'formularios');
const dbFormularios = firebaseFormularios.firestore();
const authFormularios = firebaseFormularios.auth();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');

const validarNomeImproprio = async (nomeResponsavelNormal) => {
  const nomeResponsavel = nomeResponsavelNormal.toLowerCase();
  const nomesImproprios = [
    "animais",
    "babaca",
    "bago",
    "bagulho",
    "baleiro",
    "banana",
    "bexiga",
    "boca",
    "bronha",
    "burro",
    "cabrão",
    "cagada",
    "cagar",
    "caindo",
    "caralho",
    "catapora",
    "cavalinho",
    "chato",
    "chicote",
    "clitoris",
    "cona",
    "coisa",
    "corno",
    "cuzão",
    "cuzinho",
    "dedo",
    "doido",
    "drinha",
    "embolada",
    "esgoto",
    "espada",
    "estripada",
    "faca",
    "falopa",
    "fap",
    "feca",
    "ferragil",
    "foda",
    "fodido",
    "fogosa",
    "fuder",
    "furo",
    "gansa",
    "gatilho",
    "gostoso",
    "guaxinim",
    "holerite",
    "homossexual",
    "inferno",
    "kibe",
    "kiss",
    "lol",
    "macaco",
    "mamão",
    "mamona",
    "masturbar",
    "mexer",
    "mijo",
    "miúda",
    "moleque",
    "morrer",
    "mula",
    "mulher",
    "nazi",
    "nirvana",
    "nojento",
    "nome",
    "nuca",
    "nutella",
    "olho",
    "opa",
    "orgasmo",
    "pau",
    "peide",
    "penis",
    "perereca",
    "peruca",
    "picada",
    "pinga",
    "piranha",
    "pirula",
    "pirulo",
    "pito",
    "popozuda",
    "porra",
    "pqp",
    "putaria",
    "putona",
    "rabo",
    "racha",
    "rica",
    "risada",
    "saco",
    "sapatão",
    "seios",
    "sem vergonha",
    "sexo",
    "sim",
    "siririca",
    "sujo",
    "tapete",
    "testículos",
    "traseiro",
    "trolha",
    "truk",
    "tutano",
    "vagina",
    "vsf",
    "vulva",
    "xixi",
    "bunda",
    "bundão",
    "bundinha",
    "zebra",
    "abobora",
    "bosta",
    "buceta",
    "cabra",
    "caralho",
    "chupar",
    "fdp",
    "foda",
    "foder",
    "fudido",
    "meu deus",
    "merda",
    "mijo",
    "piranha",
    "pirula",
    "pirulo",
    "puta",
    "rabo",
    "rapaz",
    "vsf",
    "tmnc",
    "pdp",
    "pcc",
    "pprt",
    "sla",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
  ];
  
  let nomeImproprioEncontrado = false;
  
  nomesImproprios.map((nomeImproprio) => {
    if (nomeResponsavel.includes(nomeImproprio)) {
      if (nomeImproprio === '.') {
        nomeImproprioEncontrado = 'ponto';
        return;
      }
      nomeImproprioEncontrado = true;
      return;
    }
  });

  if (nomeImproprioEncontrado === 'ponto') {
    Swal({
      title: 'Seu nome é impróprio por ter um ponto "."',
      icon: 'error',
      buttons: {
        confirm: 'Ok',
      },
    });
    return false;
  }
  if (nomeImproprioEncontrado) {
    Swal({
      title: 'Seu nome é impróprio!',
      icon: 'error',
      buttons: {
        confirm: 'Ok',
      },
    });
    return false;
  } else {
    return true;
  }

};

const cadastrar = async (responsavelNormal, alunoNormal, serie, email, telefoneResponsavel, telefoneAluno, senha, navigate) => {
  
  const fazerCadastro = new Promise( async (resolve, reject) => {
    const responsavel = await capitalizar(responsavelNormal);
    const aluno = await capitalizar(alunoNormal);

    const respostaValidarResponsavel = await validarNomeImproprio(responsavelNormal);
    if (!respostaValidarResponsavel) {
      resolve(false);
      return;
    }

    const respostaValidarAluno = await validarNomeImproprio(alunoNormal);
    if (!respostaValidarAluno) {
      resolve(false);
      return;
    }

    if (aluno === "") {
      Swal({
        title: 'Digite o nome do aluno!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    } else if (serie === "") {
      Swal({
        title: 'Escolha uma série!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    } else if (email === "") {
      Swal({
        title: 'Digite um email válido!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    } else if (senha === "") {
      Swal({
        title: 'Digite uma senha!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    } else if (senha.length < 6) {
      Swal({
        title: 'A senha precisa de pelo menos 6 digitos!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    }
  
    const verificacao = await verificarResponsavel(responsavel);
    if (!verificacao) {
      resolve(false);
      return;
    }

    const cadastrarEmail = await cadastrarUsuario(responsavel, email, senha);
    if (!cadastrarEmail) {
      Swal({
        title: 'Erro ao cadastrar!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    }

    await db.collection(ANO)
      .doc("responsaveis")
      .collection(responsavel)
      .doc(responsavel)
      .set({
        responsavel: responsavel,
        aluno: aluno,
        serie: serie,
        email: email,
        telefoneResponsavel: telefoneResponsavel,
        telefoneAluno: telefoneAluno,
        senha: senha
      });
    
    await db.collection(ANO)
    .doc("series")
    .collection('existente')
    .doc(serie)
    .set({
      serie: serie,
    });

    await db.collection(ANO)
    .doc("series")
    .collection(serie)
    .doc(responsavel)
    .set({
      responsavel: responsavel,
      aluno: aluno,
    }).then( async (response) => {
      //await enviarEmailObrigado(responsavel, aluno, serie, email);
      
      resolve(true);
      await Swal({
        title: 'Cadastro feito com sucesso!',
        icon: 'success',
        buttons: {
          confirm: 'Ok',
        },
      }).then( async (res) => {
        const logar = await logarResponsavel(email, senha, navigate);
      })
    })
  });

  return fazerCadastro;

}

// VALIDAR EMAILS
function validarEmail(email) {
  // Define a expressão regular
  var emails = /@([a-zA-Z0-9.-]+\.[a-zA-Z]{3,})$/;
  //var emails = /@(gmail\.com|email\.com|al\.educacao\.sp\.gov\.br|aluno\.educacao\.sp\.gov\.br)$/;

  // Use a função test para verificar se o email corresponde ao padrão
  return emails.test(email);
}

async function verificarResponsavel(responsavel) {
  if (responsavel === "") {
    Swal({
      title: 'Digite o nome do responsável!',
      icon: 'error',
      buttons: {
        confirm: 'Ok',
      },
    })
    return false;
  }
  
  try {
    const existe = await db.collection(ANO)
    .doc("responsaveis")
    .collection(capitalizar(responsavel))
    .get();
    
    if (existe.size > 0) {
      Swal({
        title: 'Responsável já existe',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      return false;
    } else {
      return true;
    }
  } catch (error) {
    console.error("Erro ao verificar responsável:", error);
    // Trate o erro conforme necessário
    return false;
  }
}


const logarResponsavel = async (email, senha, navigate) => {
  let autenticacaoCorreta = false;
  const logar = new Promise( async (resolve, reject) => {
    if (email) {
      if (senha.length >= 6) {

        try {
            const usuario = await fazerLogin(email, senha);
            
            if (usuario && senha) {
                localStorage.clear();
                const docResponsavel = await db.collection(ANO)
                .doc("responsaveis")
                .collection(usuario)
                .doc(usuario)
                .get();
                
                if (docResponsavel.exists) {
                  const val = docResponsavel.data();
                  
                  await localStorage.setItem('login', 'responsavel');
                  await localStorage.setItem("id", val.id);
                  await localStorage.setItem("tema", "light");
                  await localStorage.setItem("temaStatus", "on");
                  await localStorage.setItem('status', 'APP');
          
                  // FAZER LOGIN
                  await localStorage.setItem("logado", "RESPONSAVEL");
                  
                  // Dados do Responsavel
                  if (val.responsavel !== "") {
                    await localStorage.setItem("responsavel", val.responsavel);
                  } if (val.aluno !== "") {
                    await localStorage.setItem("aluno", val.aluno);
                  } if (val.serie !== "") {
                    await localStorage.setItem("serie", val.serie);
                  } if (val.email !== "") {
                    await localStorage.setItem("email", val.email);
                  } if (val.telefone !== "") {
                    await localStorage.setItem("telefoneResponsavel", val.telefoneResponsavel);
                  } if (val.telefoneAluno !== "") {
                    await localStorage.setItem("telefoneAluno", val.telefoneAluno);
                  } if (val.senha !== "") {
                    await localStorage.setItem("senha", val.senha);
                  } 
                  
                  if (val.usuarioSed) {
                    await localStorage.setItem('usuarioSed', val.usuarioSed);
                  } else {
                    await localStorage.setItem('usuarioSed', '');
                  }
                  
                  if (val.senhaSed) {
                    await localStorage.setItem('senhaSed', val.senhaSed);
                  } else {
                    await localStorage.setItem('senhaSed', '');
                  }
                  
                  if (val.nascimentoAluno) {
                    await localStorage.setItem('nascimentoAluno', val.nascimentoAluno);
                  } else {
                    await localStorage.setItem('nascimentoAluno', '');
                  }

                  resolve(true);
                  await Swal({
                    title: `Bem-Vindo(a) ${localStorage.getItem('responsavel')}`,
                    icon: 'success',
                    buttons: {
                      confirm: 'Ok',
                    },
                  }).then( async (resposta) => {
                    // IR PARA O HOME
                    window.location.href = "/app/";
                  });
          
                } else {
                  await Swal({
                    title: 'Este usuário foi excluído',
                    text: `Se esta conta é de sua propriedade e não houve violação alguma das normas de nosso aplicativo, por favor, entre em contato com os seguintes telefones: (16) 3324-4623, (16) 3324 2256, (16) 991190322.`,
                    icon: 'error',
                    buttons: {
                        confirm: 'Ok',
                    },
                  }).then((res) => {
                    window.location.reload();
                  });
                  resolve(false);
                };
            } else {
              // Exibir mensagem de aviso
              Swal({
                  title: 'Usuário ou senha incorretos!',
                  icon: 'error',
                  buttons: {
                      confirm: 'Ok',
                  },
              });
              resolve(false);
            }
        } catch (error) {
          // Tratar erros, se necessário
          console.error('Erro ao autenticar responsável:', error.message);
          Swal({
            title: 'Usuário ou senha incorretos!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
          });
          resolve(false);
          autenticacaoCorreta = false;
        }

      } else {
        Swal({
          title: 'A senha precisa de pelo menos 6 digitos!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
        return;
      }
    } else {
      Swal({
        title: 'Digite um email válido!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      resolve(false);
      return;
    }

    return autenticacaoCorreta;
  
  });

  return logar;
};

function capitalizar(val) {
  var texto = val;
  // Verifica se a entrada não está vazia
  if (texto.length === 0) {
    return texto;
  }
  // Divide a string em palavras
  var palavras = texto.split(' ');
  // Capitaliza a primeira letra de cada palavra
  for (var i = 0; i < palavras.length; i++) {
    palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1).toLowerCase();
  }
  // Junta as palavras de volta em uma única string
  var resultado = palavras.join(' ');
  resultado = resultado.replace(/\s+/g, ' ');
  resultado = resultado.trim();

  return resultado;
}

const logarServidor = async (email, senha) => {
  
  const logar = new Promise( async (resolve, reject) => {
    try {
      if (email && senha) {
        const servidor = await fazerLoginServidor(email, senha);
        if (!servidor) {
          resolve(false);
        }

        const loginRef = await dbFormularios.collection('controle')
        .doc('usuarios')
        .collection(servidor)
        .doc(email).get();

        if (loginRef.exists) {
          const val = loginRef.data();
          const nomeDB = val.nome;
          const servidorDB = val.servidor;
          if (servidorDB === 'funcionario') {
            Swal({
              title: 'Seu login de funcionário não tem acesso ao aplicativo!',
              icon: 'error',
            });
            resolve(false);
            return false;
          }
          
          resolve(true);
          const resposta = await entrarComServidor(servidorDB, nomeDB, email, senha);

        } else {
          Swal({
            title: 'Usuário ou senha incorretos!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
          });
          resolve(false);
        }
        
      } else {
        // Exibir mensagem de aviso
        Swal({
          title: 'Usuário ou senha incorretos!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      }
    } catch (error) {
      // Tratar erros, se necessário
      Swal({
        title: 'Usuário ou senha incorretos!',
        icon: 'error',
        buttons: {
          confirm: 'Ok',
        },
      });
      console.error('Erro ao autenticar responsável:', error.message);
      resolve(false);
    }

    // Se a execução chegou até aqui, significa que a autenticação falhou
    return false;
  });
  
  return logar;

  
};

// Função auxiliar para validar as credenciais
const validarCredenciais = (snapshot, usuario, senha) => {
  const documentos = snapshot.docs;
  for (const val of documentos) {
    const USUARIO = val.data().usuario;
    const SENHA = val.data().senha;
    if (usuario === USUARIO && senha === SENHA) {
      return true;
    }
  }
  return false;
};

// Função auxiliar para exibir a mensagem de erro
const exibirMensagemErro = () => {
  Swal({
    title: 'Usuário ou senha incorretos!',
    icon: 'error',
    buttons: {
      confirm: 'Ok',
    },
  });
};

const entrarComServidor = async (servidor, nome, email, senha) => {

  if (servidor === 'direcao') {
    await fazerLogin('direcao@e.e.prof.leticia', '19511952');
  } else if (servidor === 'coordenacao') {
    await fazerLogin('coordenacao@e.e.prof.leticia', '19511952');
  } else if (servidor === 'professor') {
    await fazerLogin('professor@e.e.prof.leticia', '19511952');
  }
  
  const entrar = new Promise( async (resolve, reject) => {
    
    localStorage.setItem('logado', servidor);
    localStorage.setItem('login', servidor);
    localStorage.setItem('usuario' , nome);
    localStorage.setItem("tema", "light");
    localStorage.setItem("temaStatus", "on");
    localStorage.setItem("email", email);
    localStorage.setItem("senha", senha);

    
    resolve(true);
    await Swal({
      title: `Bem-Vindo(a) ${localStorage.getItem('usuario')}`,
      icon: 'success',
      buttons: {
        confirm: 'Ok',
      },
    }).then( async (resposta) => {
      // IR PARA O HOME
      window.location.href = "/app/";
    });

  });
  
  return entrar;

};

const cadastrarUsuario = async (nome, email, senha) => {
  const cadastrar = new Promise( async (resolve, reject) => {
    try {
      const userCredential = await auth.createUserWithEmailAndPassword(email, senha);
      const user = userCredential.user;
      
      await user.updateProfile({
        displayName: capitalizar(nome),
      });

      if (user) {
        resolve(true);
      }

      // console.log('Usuário cadastrado com sucesso:', user);
      
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        await Swal({
          title: 'Email já está em uso!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      }
      resolve(false);
      console.error('Erro ao cadastrar usuário:', error.message);
    }
  });

  return cadastrar;

};


/* CADASTRAR OS EMAILS DO SERVIDOR
cadastrarUsuario('direcao', 'direcao@e.e.prof.leticia', '19511952')
cadastrarUsuario('coordenacao', 'coordenacao@e.e.prof.leticia', '19511952')
cadastrarUsuario('professor', 'professor@e.e.prof.leticia', '19511952')*/


// Função para realizar login
const fazerLogin = async (email, senha) => {
  const logar = new Promise( async (resolve, reject) => {
    try {
      const userCredential = await auth.signInWithEmailAndPassword(email, senha);
      const user = userCredential.user;
      const nome = user.displayName;
      
      if (nome) {
        resolve(nome);
      } else {
        resolve(true);
      }
        
    } catch (error) {
      if (error.code === 'auth/wrong-password') {
        Swal({
          title: 'Senha inválida!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/network-request-failed') {
        Swal({
          title: 'Servidor com sobrecarga, tente novamente mais tarde!',
          icon: 'warning',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/missing-password') {
        Swal({
          title: 'Senha inválida!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/invalid-email') {
        Swal({
          title: 'Email inválido!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/invalid-credential') {
        Swal({
          title: 'Email ou senha inválidos!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/user-disabled') {
        Swal({
          title: 'Sua conta foi desativada por um admin!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else {
        console.error('Erro ao fazer login:', error.message);
        resolve(false);
      }    
    }
    
  });

  return logar;
  
};

const fazerLoginServidor = async (email, senha) => {
  const logar = new Promise( async (resolve, reject) => {
    try {
      const userCredential = await authFormularios.signInWithEmailAndPassword(email, senha);
      const user = userCredential.user;
      const nome = user.displayName;
      
      if (nome) {
        resolve(nome);
      } else {
        resolve(true);
      }
        
    } catch (error) {
      if (error.code === 'auth/wrong-password') {
        Swal({
          title: 'Senha inválida!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/network-request-failed') {
        Swal({
          title: 'Servidor com sobrecarga, tente novamente mais tarde!',
          icon: 'warning',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/missing-password') {
        Swal({
          title: 'Senha inválida!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/invalid-email') {
        Swal({
          title: 'Email inválido!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/invalid-credential') {
        Swal({
          title: 'Email ou senha inválidos!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else if (error.code === 'auth/user-disabled') {
        Swal({
          title: 'Sua conta foi desativada por um admin!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
        resolve(false);
      } else {
        console.error('Erro ao fazer login:', error.message);
        resolve(false);
      }    
    }
    
  });

  return logar;
  
};


export { firebase, db, dbFormularios, auth, authFormularios, database, ANO, storage, entrarComServidor, logarResponsavel, logarServidor, cadastrar };